import { createReducer, on } from '@ngrx/store';

import * as actions from '../actions/leg-source-collection.actions';
import * as models from '../../domain/models';
import * as _ from 'lodash';

export const legSourceCollectionFeatureKey = 'legSourceCollection';

export interface State {
  loaded: boolean;
  loading: boolean;
  items: Array<models.LegSource>;
}

const initialState: State = {
  loaded: false,
  loading: false,
  items: [],
};

export const reducer = createReducer(
  initialState,

  on(
    actions.load,
    (state): State => ({
      ...state,
      loading: true,
    })
  ),
  on(
    actions.loadSuccess,
    (state, { payload }): State => ({
      ...state,
      loaded: true,
      loading: false,
      items: payload,
    })
  ),
  on(
    actions.loadFail,
    (state): State => ({
      ...state,
      loaded: true,
      loading: false,
    })
  ),

  on(actions.updateLegSourceSuccess, (state, { payload }): State => {
    const cloned = _.cloneDeep(state.items);
    const i = cloned.findIndex(({ taskTypeId }) => payload.taskTypeId === taskTypeId);
    if (i === -1) {
      return {
        ...state,
      };
    }
    cloned[i] = payload;
    return {
      ...state,
      items: cloned,
    };
  }),

  on(actions.createLegSourceSuccess, (state, { payload }): State => {
    const cloned = _.cloneDeep(state.items);
    cloned.unshift(payload);
    return {
      ...state,
      items: cloned,
    };
  }),

  on(
    actions.setInitial,
    (): State => ({
      ...initialState,
    })
  )
);
